import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';

export const G2Badges = () => {
    const query = useStaticQuery(graphql`
        query {
            allSanityG2Badges {
                nodes {
                    badges {
                        image {
                            asset {
                                gatsbyImageData(width: 400, placeholder: NONE)
                            }
                        }
                        description
                    }
                }
            }
        }
    `);

    const badges = query.allSanityG2Badges.nodes[0].badges;

    const images = badges.map(({ description, image }, index) => {
        return (
            <div key={index}>
                <GatsbyImage
                    image={image.asset.gatsbyImageData}
                    alt={description}
                    className={`tw-w-full tw-h-full`}
                    imgStyle={{ objectFit: 'contain' }}
                />
            </div>
        );
    });

    return (
        <section>
            <p className="tw-text-center md:tw-text-md tw-text-sm tw-text-neutral-dark-subdued">
                Reviewed Favorably By Industry Experts
            </p>
            <a
                href="https://www.g2.com/products/salesscreen/reviews"
                target="_blank"
                rel="noopener noreferrer"
                className={`tw-grid md:tw-grid-cols-[repeat(auto-fit,_minmax(min(100%,_80px),_120px))] tw-grid-cols-[repeat(auto-fit,_minmax(min(100%,_80px),_80px))] tw-gap-12 tw-justify-center`}
            >
                {images}
            </a>
        </section>
    );
};
